import React from 'react';

const TechdataTab = ({ selected, techdata, isButtonSelected }) => {
  if (!techdata) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{techdata.title}</h2>
      {Object.entries(techdata.data).map(([key, techdataGroup], index) => {
        if (!techdataGroup?.[0]) {
          return null;
        }

        if (!isButtonSelected(techdataGroup[0].frequency, techdataGroup[0].metric)) {
          return null;
        }

        return (
          <table className="techdata-table" key={key ?? index}>
            <tbody>
              {techdataGroup.map((tech, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{tech.size}</td>
                  <td>
                    <span dangerouslySetInnerHTML={{ __html: tech.value }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      })}
    </div>
  );
};

export default TechdataTab;
